import $ from 'jquery';
import 'bootstrap/js/dist/tooltip';
import RevealWhenVisible from '../../components/reveal-when-visible';
import CopyInputValue from '../../components/copy-value';
import ProductColorSelect from '../../components/product-color-select';
import AjaxLoadMore from './components/ajax-load-more';
import ShowElementOnClick from './components/show-element-on-click';
import HideElementOnClick from './components/hide-element-on-click';
import GiftsSlider from '../../components/gifts-slider';
import ScrollTo from '../../components/scroll-to';
import DisplayColorsInOneLine from '../../components/display-colors-in-one-line';
import VideoModalButton from '../../components/video-modal-button';
$(() => {
    RevealWhenVisible.init();
    CopyInputValue.init();
    ProductColorSelect.init();
    ShowElementOnClick.init();
    HideElementOnClick.init();
    GiftsSlider.init();
    AjaxLoadMore.init('.js__ajax-load-more');
    ScrollTo.init();
    DisplayColorsInOneLine.init();
    VideoModalButton.init();
    $('[data-toggle="tooltip"]')
        .tooltip()
        .on('click', e => {
        const target = $(e.currentTarget);
        if (target.attr('href')) {
            target.tooltip('hide');
        }
    });
});
